import { getLocale, resolveLocale, setLocale } from "@/shared/lib/i18n"
import type { User } from "./types"

/**
 * Вызывается из `__root.tsx beforeLoad` ДО первого рендера, чтобы первый
 * рендер уже подхватил серверную локаль из `user.app_language` и не было
 * вспышки неправильного языка. `setLocale(..., { reload: false })` обновляет
 * рантайм + localStorage; ререндер обеспечивает `useLocale() + key` в RootLayout.
 *
 * No-op если локаль уже совпадает с серверной.
 */
export function syncUserLocale(user: Pick<User, "app_language"> | null): void {
	if (!user) return

	// The fallback covers legacy users with `app_language === null` and values
	// outside the supported locales. Remove it after the server backfill.
	const target = resolveLocale(user.app_language)
	if (getLocale() === target) return

	setLocale(target, { reload: false })
}
